import React from 'react'
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import DatePicker from "react-datepicker";
import moment from "moment";

export default function Picker({onChange,value,placeholderText})
{
    return (
        <div className={'d-flex g-5 align-items-center'}>
            <DatePicker
                selected={value ? new Date(value) : null}
                toggleCalendarOnIconClick
                onChange={(date) => onChange(date ? moment(date).format('YYYY-MM-DD') : '')}
                isClearable
                placeholderText={placeholderText}
                showIcon={!value}
                icon={
                    <IcoMoon
                        className={'cursor-pointer'}
                        iconSet={IconSet}
                        icon={'ic_calendar'}
                        size={24}/>
                }
            />
        </div>
    )
}